<tui-root class="h-full">
    <ion-app>
        <ion-router-outlet [environmentInjector]="environmentInjector"></ion-router-outlet>
    </ion-app>
    <ng-container ngProjectAs="tuiOverContent"></ng-container>
    <ng-container ngProjectAs="tuiOverDialogs"></ng-container>
    <ng-container ngProjectAs="tuiOverAlerts"></ng-container>
    <ng-container ngProjectAs="tuiOverPortals"></ng-container>
    <ng-container ngProjectAs="tuiOverHints"></ng-container>
    <tui-sheets-host ngProjectAs="tuiOverContent"></tui-sheets-host>
</tui-root>
